export const PbkHeaders = {
  ClientId: 'x-client-id',
  TenantId: 'x-tenant-id',
  PbkFormat: 'x-pbk-format',
  UserLanguage: 'x-user-language',
  // V2 direct-call APIs collapse client + tenant into a single organization header.
  OrganizationId: 'x-organization-id',
  // Originating browser tab, echoed back on realtime events to spot our own changes.
  TabId: 'x-tab-id',
};
